import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-active-directories',
  templateUrl: './active-directories.component.html'
})
export class ActiveDirectoriesComponent implements OnInit {

s

  ngOnInit(): void {
  }

}
